(function (global) {
  'use strict';

  function syncCounter(counter) {
    if (!counter || typeof counter.closest !== 'function') return;

    var bubble = counter.closest('.cart-count-bubble');
    if (!bubble) return;

    var count = Number.parseInt(counter.textContent, 10);
    bubble.hidden = !Number.isFinite(count) || count <= 0;
  }

  function syncTree(node) {
    if (!node || node.nodeType !== 1) return;

    if (typeof node.matches === 'function' && node.matches('[data-cart-count]')) {
      syncCounter(node);
    }

    if (typeof node.querySelectorAll === 'function') {
      node.querySelectorAll('[data-cart-count]').forEach(syncCounter);
    }
  }

  function handleMutation(record) {
    var target = record.type === 'characterData' ? record.target.parentElement : record.target;

    if (target && typeof target.closest === 'function') {
      syncCounter(target.closest('[data-cart-count]'));
    }

    if (record.type === 'childList') {
      record.addedNodes.forEach(syncTree);
    }
  }

  function init(documentRef) {
    documentRef.querySelectorAll('.cart-count-bubble [data-cart-count]').forEach(syncCounter);

    var observer = new global.MutationObserver(function (records) {
      records.forEach(handleMutation);
    });
    observer.observe(documentRef.documentElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
    return observer;
  }

  global.ModabCartCountBubble = {
    syncCounter: syncCounter,
    init: init
  };

  if (global.document.readyState === 'loading') {
    global.document.addEventListener('DOMContentLoaded', function () {
      init(global.document);
    }, { once: true });
  } else {
    init(global.document);
  }
})(window);
